export default function handleBadgesStyle(asBadges, badgesStyle, styles) {
  if (asBadges) {
    if (badgesStyle === 1) return styles._badges_style_one;
    else if (badgesStyle === 2) return styles._badges_style_two;
  }
}
